import React from 'react'
import { createDivAtom } from 'shared/atoms/factory'

import styles from './NotFoundPage.module.scss'

const Title = createDivAtom(),
      SubTitle = createDivAtom()

const NotFoundPage = () => (
  <main className={styles.wrapper}>
    <Title className={styles.title}>
      404 Error
    </Title>

    <SubTitle className={styles.subTitle}>
      Not Found
    </SubTitle>
  </main>
)

export default NotFoundPage
